import axios from "axios";

const endpoint = 'role';

export default {
    async getAsync() {
        const response = await axios.get(`${endpoint}`);
        return response.data;
    },
}
